import { render, staticRenderFns } from "./anwarida-query.vue?vue&type=template&id=367294a2"
import script from "./anwarida-query.vue?vue&type=script&lang=js"
export * from "./anwarida-query.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports